import Editor from './editor.vue';
export default Editor;


// WEBPACK FOOTER //
// ./src/components/editor/index.js